export default "__VITE_ASSET__DuZUI9Pl__"